export default "__VITE_ASSET__QAh$vgUN__"